import BaseApi from '@/core/HttpResources/BaseApi';
import Role from '@/models/security/role.model';

export default class RoleService {
    
    baseApiRol = new BaseApi("role");

    async getRoles(): Promise<Array<Role>> {
        return new Promise<Array<Role>>((resolve, reject) => this.baseApiRol.request('GET', 'permissions', null, {}, (response) => resolve(response.data), reject, () => { }))
    }
    
    async saveRol(rol: Role): Promise<Role> {
        return new Promise<Role>((resolve, reject) => this.baseApiRol.request('POST', String(), rol, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async updateRol(rol: Role): Promise<Role> {
        return new Promise<Role>((resolve, reject) => this.baseApiRol.request('PUT', "" + rol.id, rol, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async deleteRol(rolId: number): Promise<Role> {
        return new Promise<Role>((resolve, reject) => this.baseApiRol.request('DELETE', "" + rolId, null, {}, (response) => resolve(response.data), reject, () => { }))
    }

    async getPermisionGroupedByCategory(): Promise<Array<any>> {
        var baseApi = new BaseApi("Permission/group/category");
        return new Promise<Array<any>>((resolve, reject) => baseApi.request('GET', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }
}